// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__r9nrE","sk-bouncedelay":"Loader_sk-bouncedelay__3uKXO","bounce1":"Loader_bounce1__1dHiQ","bounce2":"Loader_bounce2__2tJVD"};